module.exports = __webpack_public_path__ + "img/DE02266.58105716.png";